<div
  class="create-message-input-container"
  *ngIf="{
    selectedProfile: selectedProfile$ | async,
    getSubmitting: getSubmitting$ | async
  } as obs"
>
  <form
    [formGroup]="messageForm"
    *ngIf="!obs.getSubmitting"
    class="create-message-input-form"
    (ngSubmit)="onSubmit(obs.selectedProfile)"
  >
    <mat-form-field class="message-input-container">
      <textarea
        matInput
        formControlName="message"
        class="message-input"
        rows="1"
        [maxlength]="maxChar"
        cdkTextareaAutosize
        (blur)="messageForm.markAsUntouched()"
        placeholder="{{ placeholder | translate }} "
      ></textarea>
    </mat-form-field>
    <div
      class="counter"
      *ngIf="{
        counterValue: counterValue$ | async
      } as obs"
    >
      <span>{{ obs.counterValue ? obs.counterValue : 0 }} / {{ maxChar }} </span>
    </div>

    <div class="button-container">
      <button
        *ngIf="!!parentPost"
        mat-stroked-button
        class="send-button"
        type="button"
        (click)="cancelReply()"
        aria-label="CANCEL"
      >
        <span translate="ACTIVITY_FEED.CANCEL"></span>
      </button>
      <button
        mat-raised-button
        class="send-button"
        type="submit"
        [color]="'primary'"
        [disabled]="messageForm.invalid"
        aria-label="SEND"
      >
        <span translate="ACTIVITY_FEED.SEND"></span>
      </button>
    </div>
  </form>
  <div class="spinner-container">
    <mat-spinner diameter="50" *ngIf="obs.getSubmitting"></mat-spinner>
  </div>
</div>
